// This utility is intended to deal specifically with our
// "crypto-prefixed" convention. Example `ethereum.0x123...456`.
import { type SupportedChain, type SupportedNetworkName } from '@pkg/types';

export function extractCryptoAddress(value: string | number = '') {
    const safeValue = `${value}`;
    const dotIndex = safeValue.indexOf('.');
    return dotIndex === -1 ? safeValue : safeValue.slice(dotIndex + 1);
}

export function normalizeAddress(address: string, prefix = '0x') {
    return address.startsWith(prefix) ? address : `${prefix}${address}`;
}

export function truncateContractAddress(value: string | number = '', includeCryptoPrefix = false) {
    const safeValue = `${value}`;
    const dotIndex = safeValue.indexOf('.');

    const prefixOffset = includeCryptoPrefix && dotIndex !== -1 ? dotIndex + 1 : 0;
    const prefixLength = 6 + prefixOffset;
    const suffixLength = 4;

    const segments = [safeValue.slice(0, prefixLength), '…', safeValue.slice(suffixLength * -1)];

    return safeValue.length > prefixLength + suffixLength ? segments.join('') : safeValue;
}

export function capitalizeFirstLetter(value?: SupportedChain): SupportedNetworkName {
    return value ? ((value?.charAt(0).toUpperCase() + value?.slice(1)) as SupportedNetworkName) : 'Ethereum';
}

export function convertNetworkToChain(value?: SupportedNetworkName): SupportedChain {
    return value?.toLowerCase() as SupportedChain;
}
